import { Modal as AntModal, Row } from 'antd';
import styled from 'styled-components';

export const TitleWrapper = styled(Row)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 32px;
`;

export const Modal = styled(AntModal)`
  min-width: 560px;
`;

export const ContentWrapper = styled.div`
  padding: 24px 0 8px;
`;
